import { useMutation } from "@tanstack/react-query";

import http from "../../../http";
import { CREATE_DRAFT } from "../../URL";
import { IFeeCalculationRequest } from "../../../interfaces";

interface IAxisErrorResponse {
  response?: {
    data?: string;
  };
}

const createDraft = async (filing: IFeeCalculationRequest) => {
  const response = await http.post<number>(CREATE_DRAFT, filing);
  return response?.data;
};

const useCreateDraft = () =>
  useMutation<number, IAxisErrorResponse, IFeeCalculationRequest>({
    mutationKey: ["create-draft"],
    mutationFn: createDraft,
  });

export default useCreateDraft;
